import styled from "styled-components"

export const WaterWrapper = styled.div`
  --header-height: 44px;
  --cta-box-height: 72px;

  height: 100%;
  width: 100%;
  background: #f5f7f7;
`

export const WaterLogContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 24px;
  height: calc(100% - var(--header-height) - var(--app-cta-height));
  background: #f5f7f7;
  padding-top: 12px;
  overflow-y: auto;
`

export const AddConsumptionCard = styled.div`
  background: #fff;
  border: 0.5px solid rgba(0, 38, 58, 0.14);
  border-radius: 8px;
  padding: 8px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const AddConsumptionTitle = styled.h3`
  font-weight: 700;
  font-size: 14px;
  line-height: 1.6;
  color: #1c1f21;
  padding: 0 16px;
  margin: 0;
`

export const WaterItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 8px 0 8px;
`

export const WaterItemWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 44px;
  border-radius: 8px;
`

export const WaterItemLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  height: 100%;
`

export const WaterItemIconBox = styled.div<{ $active?: boolean }>`
  width: 32px;
  height: 100%;
  display: flex;
  align-items: flex-start;
  padding-top: 2px;
  opacity: ${(props) => (props.$active ? 1 : 0.32)};
`

export const WaterItemLabelBox = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`

export const WaterItemValue = styled.span`
  font-weight: 600;
  font-size: 16px;
  line-height: 1.6;
  color: #1c1f21;
`

export const WaterItemUnit = styled.span`
  font-weight: 400;
  font-size: 16px;
  line-height: 1.2;
  color: #69757d;
`

export const WaterItemCountBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: 12px;
`

export const WaterItemCountDot = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  border: 1px solid #1c1f21;
`

export const WaterItemCountNumber = styled.span`
  font-weight: 400;
  font-size: 16px;
  line-height: 1.2;
  color: #1c1f21;
`

export const WaterItemControls = styled.div`
  display: flex;
  align-items: center;
`

export const ControlButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  padding: 6px 4px;
`

export const ControlButton = styled.button<{ $disabled?: boolean }>`
  width: 32px;
  height: 32px;
  border-radius: 20px;
  border: none;
  background: #f5f7f7;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${(props) => (props.$disabled ? "not-allowed" : "pointer")};
  padding: 4px;

  &:active:not(:disabled) {
    background: rgba(13, 163, 186, 0.16);
  }
`

export const CtaContainer = styled.div`
  margin-top: auto;
  padding: 16px 0 24px;
`

export const LogWaterButton = styled.button<{ $disabled?: boolean }>`
  width: 100%;
  height: 48px;
  border-radius: 100px;
  border: none;
  background: ${(props) =>
    props.$disabled ? "rgba(0, 38, 58, 0.14)" : "#4bd9de"};
  cursor: ${(props) => (props.$disabled ? "not-allowed" : "pointer")};

  font-weight: 700;
  font-size: 16px;
  line-height: 16px;
  letter-spacing: 0.16px;
  color: ${(props) => (props.$disabled ? "#69757d" : "#023648")};
  text-align: center;

  &:active:not(:disabled) {
    opacity: 0.9;
  }
`
